import {styled} from '@mui/material/styles';
import {SIZES} from '@fupa/fupa-uikit';

export const UndecoratedATag = styled('a')<{margin?: boolean}>`
  text-decoration: none;
  margin-right: ${(props) => (props.margin ? SIZES['16'] : '0')};
  @media all and (max-width: 800px) {
    margin-right: ${(props) => (props.margin ? SIZES['8'] : '0')};
  }
  &:active,
  &:visited {
    text-decoration: none;
  }
`;
